import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { umsUrl } from '../../../../Containers/Config/index.js';
import { Constant } from '../../../../Containers/Helpers/constant.js';
import {
  CLIENT_LOGIN_V2,
  CLIENT_LOGIN_V2_SUCCESS,
  CLIENT_LOGIN_V2_ERROR,
  CLIENT_VALIDATE_OTP_V2,
  CLIENT_VALIDATE_OTP_V2_SUCCESS,
  CLIENT_VALIDATE_OTP_V2_ERROR,
  CLIENT_RESEND_OTP_V2,
  CLIENT_RESEND_OTP_V2_SUCCESS,
  CLIENT_RESEND_OTP_V2_ERROR,
} from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';

const clientLoginHeaders = {
  'Content-Type': 'application/json',
  get 'Project-Code'() {
    return Constant.HOSTNAME_PROJECT_CODE;
  },
};

const getAuthorizationHeader = token => {
  if (!token) return '';
  return token?.startsWith?.('Bearer ') ? token : `Bearer ${token}`;
};

function* clientLoginV2({ payload }) {
  try {
    const { recaptchaToken, ...loginData } = payload?.data || {};

    const response = yield call(apiCall, {
      url: `${umsUrl}/admin/v2/client/login`,
      method: 'POST',
      data: loginData,
      headers: {
        ...clientLoginHeaders,
        ...(recaptchaToken && { 'X-Recaptcha-Token': recaptchaToken }),
      },
    });

    if (response.status === 200) {
      yield put({ type: CLIENT_LOGIN_V2_SUCCESS, payload: response });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({ type: CLIENT_LOGIN_V2_ERROR, payload: response?.data?.message });
    }
  } catch (error) {
    yield put({ type: CLIENT_LOGIN_V2_ERROR, payload: error });
  }
}

function* clientValidateOtpV2({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${umsUrl}/admin/v2/client/validate-otp`,
      method: 'POST',
      data: payload?.data,
      headers: {
        ...clientLoginHeaders,
        Authorization: getAuthorizationHeader(payload?.headers?.token),
      },
    });

    if (response.status === 200) {
      yield put({ type: CLIENT_VALIDATE_OTP_V2_SUCCESS, payload: response });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({ type: CLIENT_VALIDATE_OTP_V2_ERROR, payload: response?.response?.data?.message || response?.data?.message });
    }
  } catch (error) {
    yield put({ type: CLIENT_VALIDATE_OTP_V2_ERROR, payload: error });
  }
}

function* clientResendOtpV2({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${umsUrl}/admin/v2/client/resend-otp`,
      method: 'POST',
      headers: {
        ...clientLoginHeaders,
        Authorization: getAuthorizationHeader(payload?.headers?.token),
      },
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message || 'OTP resent successfully');
      yield put({ type: CLIENT_RESEND_OTP_V2_SUCCESS, payload: response });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({ type: CLIENT_RESEND_OTP_V2_ERROR, payload: response?.response?.data?.message || response?.data?.message });
    }
  } catch (error) {
    yield put({ type: CLIENT_RESEND_OTP_V2_ERROR, payload: error });
  }
}

export function* watchClientLoginV2() {
  yield takeEvery(CLIENT_LOGIN_V2, clientLoginV2);
}

export function* watchClientValidateOtpV2() {
  yield takeEvery(CLIENT_VALIDATE_OTP_V2, clientValidateOtpV2);
}

export function* watchClientResendOtpV2() {
  yield takeEvery(CLIENT_RESEND_OTP_V2, clientResendOtpV2);
}

function* clientLoginV2Saga() {
  yield all([fork(watchClientLoginV2), fork(watchClientValidateOtpV2), fork(watchClientResendOtpV2)]);
}

export default clientLoginV2Saga;
